import { ProxyScrapeError } from '../../core/errors';
import type { HttpClient } from '../../core/http';

/**
 * Stub for the dedicated proxies module. Real implementation lands once
 * the v4 endpoints are stable. Public methods are an intentional commitment
 * to the v1.x surface — only the bodies fill in.
 *
 * The HttpClient reference is held even though the stub methods don't use
 * it yet — that way the constructor isn't "useless" (it really will be
 * needed) and the eventual implementation slots in without touching the
 * constructor signature or callers.
 */
export class DedicatedClient {
  constructor(protected readonly http: HttpClient) {}

  acquire(_params?: Record<string, unknown>): Promise<never> {
    return Promise.reject(notImplemented('dedicated.acquire'));
  }

  release(_params?: Record<string, unknown>): Promise<never> {
    return Promise.reject(notImplemented('dedicated.release'));
  }

  list(_params?: Record<string, unknown>): Promise<never> {
    return Promise.reject(notImplemented('dedicated.list'));
  }
}

function notImplemented(name: string): ProxyScrapeError {
  return new ProxyScrapeError(
    `${name}() is not implemented in this SDK version. The dedicated module is scaffolded for a future release — track https://github.com/ProxyScrape/proxyscrape-sdk/issues for status.`,
  );
}
